import React from "react";
import ReactTooltip from "react-tooltip";
import {Help as HelpIcon} from "@material-ui/icons";

const HelpToolTip = ({tip, effect, place, style}) => (
  <span style={style}>
    <ReactTooltip />
    <HelpIcon
      style={{width: 16, color: "#444", zIndex: 1000}}
      data-tip={tip}
      data-effect={!effect ? "solid" : effect}
      data-place={!place ? "right" : place}
    />
  </span>
);

export default HelpToolTip;



// WEBPACK FOOTER //
// ./src/components/HelpToolTip/index.jsx